import environment from '../../common/environment';
import { EventLogRequest } from './event-logger.interface';
import { getResponseData } from '../../common/utils/api-utils';

/**
 * Triggers the event logger API call
 *
 * @param requestBody
 */
export function postEventLoggerApiCall(requestBody: EventLogRequest): void {
  if (!environment().enableEventLogger) {
    return;
  }

  const url = new URL(`${environment().magentoUrl}${postEventLoggerMagento()}`);
  getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
  );
}

export const postEventLoggerMagento = () => `/shop/rest/${environment().checkoutFlow}/V1/event-logger`;
